var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSearch = function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#405261",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12.059,
    cy: 12.059,
    r: 7.062
  }), /*#__PURE__*/React.createElement("path", {
    d: "m21.003 21.003-3.951-3.951"
  }))));
};
export { SvgSearch as ReactComponent };
export default "data:image/svg+xml;base64,ZXhwb3J0IGRlZmF1bHQgX193ZWJwYWNrX3B1YmxpY19wYXRoX18gKyAiZjg3YmU3YTUyYThiMGRjM2YzMTY2YmVhOTc5ZDI1MGQuc3ZnIjs=";